import * as graphql from '@attain-apps/fe/web/main/lib/graphql'
import * as transformers from '@attain-apps/transformers'
import gql from 'graphql-tag'

export const DOC = gql`
  query DataDownloadRequest(
    $tenantId: ID!
    $zoneId: ID!
    $fileInput: FileInput!
  ) {
    tenant(id: $tenantId) {
      zone(id: $zoneId) {
        dataDownloadRequest(fileInput: $fileInput)
      }
    }
  }
`

const TRANSFORMER = graphql.transformers.OUT.nonNull(
  graphql.transformers.OUT.select<
    graphql.schema.DataDownloadRequestQuery,
    string,
    'tenant'
  >(
    'tenant',
    graphql.transformers.OUT.select(
      'zone',
      // NOTE: if we do not receive a url, we actually want to throw an
      // error since we can't really proceed with the download
      graphql.transformers.OUT.select(
        'dataDownloadRequest',
        transformers.PASS_THROUGH,
      ),
    ),
  ),
)

export const execute = graphql.createExecutor<
  graphql.schema.DataDownloadRequestQuery,
  string,
  graphql.schema.DataDownloadRequestQueryVariables
>({
  query: DOC,
  transformer: TRANSFORMER,
})
